// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-tab {
  width: 100%;
  position: fixed;
  z-index: 900;
  margin: 0 auto;
  background-color: #fcfdfd;
}

.nav-tab__list {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 25px;
  list-style-type: none;
  padding: 10px 40px;
  margin: 0 auto;
}

.nav-tab__link {
  font-family: Oswald-light, sans-serif;
  font-weight: 300;
  text-transform: uppercase;
  min-height: 30px;
  font-size: 15px;
  text-decoration: none;
  border: none;
  border-radius: 5px;
  background-size: cover;
  background-position: center;
  background-color: #fcfdfd;
}

.nav-tab__link:hover {
  color: #073042;
  background-color: #f0f0f0;
}

.nav-tab__hidden {
  display: none;
}

@media screen and (max-width: 768px) {
  .non-mobile-style {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: #0000004d;
    z-index: 1000;
    transition: all 0.4s linear;
    margin: 0;
    padding: 0;
  }

  .nav-tab__wrapper {
    position: fixed;
    width: 38%;
    height: 100vh;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    box-shadow: 0px 4px 4px 0px #00000040, 0px 4px 4px 0px #00000040;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 15%;
    padding: 0;
  }
  .nav-tab__list {
    padding: 20px 0;
    flex-direction: column;
    justify-content: normal;
    align-items: center;
    gap: 10px;
  }
  .nav-tab__link {
    padding: 5px 30px;
  }

  .nav-tab__close-burger {
    border: none;
  }
  .nav-tab__close-burger img {
    max-height: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/NavTab/NavTab.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,aAAa;IACb,2BAA2B;IAC3B,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,UAAU;IACV,aAAa;IACb,MAAM;IACN,QAAQ;IACR,SAAS;IACT,sBAAsB;IACtB,gEAAgE;IAChE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,QAAQ;IACR,UAAU;EACZ;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".nav-tab {\n  width: 100%;\n  position: fixed;\n  z-index: 900;\n  margin: 0 auto;\n  background-color: #fcfdfd;\n}\n\n.nav-tab__list {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 25px;\n  list-style-type: none;\n  padding: 10px 40px;\n  margin: 0 auto;\n}\n\n.nav-tab__link {\n  font-family: Oswald-light, sans-serif;\n  font-weight: 300;\n  text-transform: uppercase;\n  min-height: 30px;\n  font-size: 15px;\n  text-decoration: none;\n  border: none;\n  border-radius: 5px;\n  background-size: cover;\n  background-position: center;\n  background-color: #fcfdfd;\n}\n\n.nav-tab__link:hover {\n  color: #073042;\n  background-color: #f0f0f0;\n}\n\n.nav-tab__hidden {\n  display: none;\n}\n\n@media screen and (max-width: 768px) {\n  .non-mobile-style {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100vh;\n    background-color: #0000004d;\n    z-index: 1000;\n    transition: all 0.4s linear;\n    margin: 0;\n    padding: 0;\n  }\n\n  .nav-tab__wrapper {\n    position: fixed;\n    width: 38%;\n    height: 100vh;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #fff;\n    box-shadow: 0px 4px 4px 0px #00000040, 0px 4px 4px 0px #00000040;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 15%;\n    padding: 0;\n  }\n  .nav-tab__list {\n    padding: 20px 0;\n    flex-direction: column;\n    justify-content: normal;\n    align-items: center;\n    gap: 10px;\n  }\n  .nav-tab__link {\n    padding: 5px 30px;\n  }\n\n  .nav-tab__close-burger {\n    border: none;\n  }\n  .nav-tab__close-burger img {\n    max-height: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
